import axiosInstance from './axiosInstance';

/**
 * Get unread notification count
 * @returns {Promise} Response with unread count
 */
export const getUnreadNotificationCount = async () => {
  const response = await axiosInstance.get('/users/me/messages/unread-count');
  return response.data;
};

/**
 * Get notification list
 * @param {Object} params - Query parameters
 * @param {string} params.category - Category filter (ALL, PROMOTION, PURCHASE, SALE, ACCOUNT, SYSTEM)
 * @param {boolean} params.unreadOnly - Filter for unread only
 * @param {string} params.cursor - Pagination cursor
 * @param {number} params.limit - Page size
 * @returns {Promise} Response with notification list
 */
export const getNotifications = async (params = {}) => {
  const response = await axiosInstance.get('/users/me/messages', { params });
  return response.data;
};

/**
 * Mark all unread messages as read
 * @returns {Promise} Response
 */
export const markAllNotificationsAsRead = async () => {
  const response = await axiosInstance.post('/users/me/messages/read');
  return response.data;
};

/**
 * Mark a specific message as read
 * @param {string} messageId - The message ID to mark as read
 * @returns {Promise} Response
 */
export const markNotificationAsRead = async (messageId) => {
  const response = await axiosInstance.post(`/users/me/messages/${messageId}/read`);
  return response.data;
};
